import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.auctions')
  .factory('$auction', AuctionObjectFactory);

/* @ngInject */
function AuctionObjectFactory($bringozFactory: $bringozFactory,
                              AuctionsAPI: BringozApi,
                              Auctions_DS: DataStoreConfig,
                              Auctions_PN: PushNotificationsConfig) {
  function $auction(id: string) {
    return $bringozFactory(id, AuctionsAPI, Auctions_DS, Auctions_PN)
  }

  return $auction;
}

